<template>
    <div>
        <headline-container headline="Edit Legal Text" :breadcrumbs="breadcrumbs">
            <button type="button" class="btn btn-white pull-right" @click="destroy">
                <i class="fa fa-trash"></i> Delete
            </button>
        </headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Edit Legal Text
                        </h3>

                        <p>
                            Enter the details of the legal text.
                        </p>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit">
                                <text-form-group
                                        v-model="data.name"
                                        name="name"
                                        label="Name"
                                        help-text="The name of the legal text."
                                        :error="getError('name')"
                                ></text-form-group>

                                <ck-editor-form-group
                                        v-model="data.content"
                                        name="content"
                                        label="Content"
                                        help-text="The content of the legal text."
                                        :error="getError('content')"
                                ></ck-editor-form-group>

                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import CkEditorFormGroup from "@/vendor/forms/FormGroups/Block/CkEditor"
    import Errors from '@/mixins/Errors'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
    import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

    export default {
        components: {
            CkEditorFormGroup,
            HeadlineContainer,
            HelpText,
            LoadingContainer,
            SubmitFormGroup,
            TextFormGroup
        },

        mixins: [Errors],

        props: ['id'],

        data() {
            return {
                data: null,

                loading: true
            }
        },

        mounted() {
            http.get('/api/v2/legal-texts/' + this.id).then(response => {
                this.data = response.data.data.attributes

                this.loading = false
            })
        },

        computed: {
            breadcrumbs() {
                return [
                    {url: '/legal-texts', text: 'Legal Texts'},
                    {text: 'Edit'}
                ]
            }
        },

        methods: {
            submit() {
                http.put('/api/v2/legal-texts/' + this.id, this.data)
                    .then(() => {
                        notify.success('The legal text was saved')

                        this.$router.push('/legal-texts')
                    })
                    .catch(this.catchValidationErrors)
            },

            destroy() {
                modal.confirm('Are you sure that you want to delete the legal text?', () => {
                    http.delete('/api/v2/legal-texts/' + this.id)
                        .then(() => {
                            notify.success('The legal text was deleted')

                            this.$router.push('/legal-texts')
                        })
                })
            }
        }
    }
</script>

<style>
    .ck-editor__editable {
        min-height: 400px;
    }
</style>
